// index.ts
import { circle } from "@turf/circle";
import { destination } from "@turf/destination";
import { lineString } from "@turf/helpers";
function lineArc(center, radius, bearing1, bearing2) {
    var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var steps = options.steps || 64;
    var angle1 = convertAngleTo360(bearing1);
    var angle2 = convertAngleTo360(bearing2);
    var properties = !Array.isArray(center) && center.type === "Feature" ? center.properties : {};
    if (angle1 === angle2) {
        return lineString(circle(center, radius, options).geometry.coordinates[0], properties);
    }
    var arcStartDegree = angle1;
    var arcEndDegree = angle1 < angle2 ? angle2 : angle2 + 360;
    var alpha = arcStartDegree;
    var coordinates = [];
    var i = 0;
    var arcStep = (arcEndDegree - arcStartDegree) / steps;
    while(alpha <= arcEndDegree){
        coordinates.push(destination(center, radius, alpha, options).geometry.coordinates);
        i++;
        alpha = arcStartDegree + i * arcStep;
    }
    return lineString(coordinates, properties);
}
function convertAngleTo360(alpha) {
    var beta = alpha % 360;
    if (beta < 0) {
        beta += 360;
    }
    return beta;
}
var turf_line_arc_default = lineArc;
export { turf_line_arc_default as default, lineArc }; //# sourceMappingURL=index.js.map
